import classNames from 'classnames';
import { stringify } from 'qs';
import { useCallback } from 'react';
import { Button } from 'yoso';
import { authLogoutUrl } from '~/components/Auth';
import { myCitizenItemsUrl } from '~/components/Dosi/Dosi.hooks';
import { agent } from '~/components/Dosi/Vault';
import { useEmbeddedViewer } from '~/components/Embedded/Embedded.hooks';
import { T } from '~/components/I18n';
import { Chevron } from '~/components/Icon/Chevron';
import { InlineList } from '~/components/List/Inline/InlineList';
import styles from './DosiProfileNav.module.scss';

const PROFILE_URL = import.meta.env.VITE_PROFILE_URL;
const DOSI_URL = import.meta.env.VITE_DOSI_URL;

export type DosiProfileNavProps = {
  className?: string;
  direction?: 'row' | 'column';
  onClick?: () => void;
};

export const DosiProfileNav = ({ className, direction = 'row', onClick }: DosiProfileNavProps) => {
  const isRow = direction === 'row';
  const isApp = agent;
  const { open } = useEmbeddedViewer();

  const handleProfileClick = useCallback(() => {
    open(`${PROFILE_URL}?${stringify({ logout_url: authLogoutUrl })}`);
    onClick?.();
  }, [onClick, open]);

  const handleHoldingClick = useCallback(() => {
    open(myCitizenItemsUrl);
    onClick?.();
  }, [onClick, open]);

  const handleLikesClick = useCallback(() => {
    open(`${DOSI_URL}/profile/me/likes/nfts`);
    onClick?.();
  }, [onClick, open]);

  return (
    <InlineList divided={isRow} className={classNames(styles.root, className, styles[direction])}>
      {!isApp && (
        <li>
          <Button
            onClick={handleProfileClick}
            variant="text"
            data-event="click"
            data-event-target="mypage">
            <T name="citizen_drawer_mypage" />
            <Chevron direction="right" className={styles.chevron} />
          </Button>
        </li>
      )}
      <li>
        <Button
          onClick={handleHoldingClick}
          variant="text"
          data-event="click"
          data-event-target="myitems">
          <T name="citizen_drawer_myitems" />
          <Chevron direction="right" className={styles.chevron} />
        </Button>
      </li>
      <li>
        <Button
          onClick={handleLikesClick}
          variant="text"
          data-event="click"
          data-event-target="mylikes">
          <T name="citizen_drawer_mylikes" />
          <Chevron direction="right" className={styles.chevron} />
        </Button>
      </li>
    </InlineList>
  );
};
